exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-carousel {\n  height: 85%;\n  margin-left: 6em;\n  position: relative;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  font-size: 0.775em; }\n  .home-carousel__slide {\n    height: 100%;\n    display: inline-block;\n    width: 35%;\n    position: absolute;\n    transition: 0.3s ease;\n    padding: 0 0.7em; }\n", ""]);

// exports
